import {
  core_v1_DataSource,
  coreV1CreateDataSourceMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { setClientOfOrigin } from '@/utils/setClientOfOrigin';

export const useCreateDataSource = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({ data }: { data: core_v1_DataSource }) => {
      const dataWithClientOrigin = setClientOfOrigin(data);
      return coreV1CreateDataSourceMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: dataWithClientOrigin, path: { workspace } });
    },
  });
};
